import React from 'react'
import DocumentsPanel from "./DocumentsPanel";

function Index(
    {
        expanded,
    }) {
    return (expanded && <DocumentsPanel/>)
}


export default Index;